/**
 * Formats a number as a price string in LKR with two decimal places.
 * Example: 200 => "LKR 200.00", 1100 => "LKR 1,100.00"
 */
export const formatPrice = (price: number): string => {
  return `LKR ${price.toLocaleString('en-LK', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

/**
 * Formats a number to a string with two decimal places without the LKR currency code prefix.
 * Example: 200 => "200.00", 1100 => "1,100.00"
 */
export const formatPriceRaw = (price: number): string => {
  return price.toLocaleString('en-LK', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
